/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        var el = document.querySelector('.moya__banner.hasCarousel');
        if (!el) {
            return;
        }
        var items = el.querySelector('.items');
        if (window['site'] && window['site'].owl && items.children.length > 1) {
            var owl = window['site'].owl.init(items, {
                loop: !!+el.getAttribute('data-loop') || !!+el.getAttribute('data-autoplay'),
                dots: !!+el.getAttribute('data-dots'),
                nav: !!+el.getAttribute('data-nav'),
                autoplay: !!+el.getAttribute('data-autoplay'),
                autoplayTimeout: el.getAttribute('data-autoplaytimeout') ? el.getAttribute('data-autoplaytimeout') : 8000,
                autoplayHoverPause: true,
                smartSpeed: 800,
                items: 1,
                navText: ["", ""]
            });
            if (owl) {
                owl.on('translate.owl.carousel', function (event) {
                    el.classList.add('translate');
                });
                owl.on('drag.owl.carousel', function (event) {
                    el.classList.add('translate');
                });
                owl.on('translated.owl.carousel', function (event) {
                    el.classList.remove('translate');
                });
            }
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
